(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("url-image-source", [], factory);
	else if(typeof exports === 'object')
		exports["url-image-source"] = factory();
	else
		root["url-image-source"] = factory();
})(self, function() {
return 